import { render, staticRenderFns } from "./modal-details.vue?vue&type=template&id=f5ea6136"
import script from "./modal-details.vue?vue&type=script&lang=js"
export * from "./modal-details.vue?vue&type=script&lang=js"
import style0 from "./modal-details.vue?vue&type=style&index=0&id=f5ea6136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports